module.exports = __webpack_public_path__ + "static/media/login.70b99434.jpg";